import { useCallback } from 'react';
import { Key } from 'w3c-keys';

function useButtonRole({
  checkForDefaultPrevented = true,
  disabled = false
} = {}) {
  const click = useCallback(
    (eventHandler) => {
      return function handleMouseEvent(event) {
        const defaultPreventCheck = checkForDefaultPrevented === false || !event.defaultPrevented;
        if (defaultPreventCheck && disabled === false) {
          return eventHandler(event);
        }
      };
    },
    [checkForDefaultPrevented, disabled]
  );
  const keydown = useCallback(
    (eventHandler) => {
      return function handleKeydownEvent(event) {
        const isActionKey = event.key === Key.Enter || event.key === Key.Space;
        const defaultPreventCheck = checkForDefaultPrevented === false || !event.defaultPrevented;
        if (defaultPreventCheck && disabled === false && isActionKey) {
          event.preventDefault();
          return eventHandler(event);
        }
      };
    },
    [checkForDefaultPrevented, disabled]
  );
  return {
    htmlProps: {
      role: "button",
      tabIndex: 0,
      ["aria-disabled"]: disabled
    },
    handler: {
      click,
      keydown
    }
  };
}

export { useButtonRole as default };
//# sourceMappingURL=useButtonRole.mjs.map
